import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {MenuItem, MenuList} from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import PeopleIcon from '@material-ui/icons/People';
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import {navigate} from "gatsby"
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SendIcon from '@material-ui/icons/Send';


const useStyles = makeStyles(theme => ({}));

export default function SideNavigation(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.initialState);

    const handleClick = () => {
        setOpen(!open);
    };

    const categoryMap = props.categories.reduce((acc, cur) => ({...acc, [cur.title]: cur.slug}), {});
    const {navItems: {rechtsgebiete}} = props;
    const {currentCategory} = props;

    const navlist = rechtsgebiete.map((item,i) => {
        return (
            <MenuItem button className={classes.nested}
                      onClick={() => navigate(`/${categoryMap[item.category]}/${item.slug}`)}
                      key={item.slug}
            >
                <ListItemIcon>
                    <SendIcon/>
                </ListItemIcon>
                <ListItemText primary={item.title}/>
            </MenuItem>
        )
    });

    return (
        <MenuList>
            <div>
                <MenuItem button onClick={handleClick}>
                    <ListItemIcon>
                        <PeopleIcon/>
                    </ListItemIcon>
                    <ListItemText primary={currentCategory}/>
                    {open ? <ExpandLess/> : <ExpandMore/>}
                </MenuItem>

                <Collapse in={open} timeout="auto" unmountOnExit>
                    <MenuList component="div" disablePadding>
                        {navlist}
                        {props.children}
                    </MenuList>
                </Collapse>
            </div>
        </MenuList>
    );
}


